<span class="badge badge-info">
    <vn-icon name="theme-badge" class="icon" size="10"></vn-icon> <span class="title">{{ promotionTitle }}</span>
</span>
